import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_Property_Contact } from '../../../../../constants/APIs';

export default class PropertyContact extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGenerator getUrl={gAPI_Property_Contact} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
